import { cn } from '@newcore/ui/cn';
import { Sizes } from '@newcore/ui/enums/sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Input, type InputProps } from '@newcore/ui/inputs';
import { textVariants } from '@newcore/ui/variants/typography-text-variants';

export type LoginInputProps = Omit<InputProps, 'size'>;

// Login inputs keep the pre-design-system geometry: 50px tall, 8px radius,
// flat (no elevation), 14px text (index.css bumps this to 16px under 767px to
// stop iOS Safari zoom-on-focus, matching admin-console/user-portal), and a
// near-black focus border instead of the design-system brand ring. `!` forces
// the focus color over inputVariants' brand border/outline rules (including
// focus+hover). Skip it when invalid so the shared error border/outline wins.
const LOGIN_CHROME = 'h-12.5 rounded-md px-3 shadow-none';
const LOGIN_FOCUS =
  'not-has-[[aria-invalid=true]]:focus-within:border-fg-primary! not-has-[[aria-invalid=true]]:focus-within:outline-transparent!';
const LOGIN_TEXT = textVariants({ size: TextSizes.SM });

export function LoginInput({
  className,
  inputClassName,
  ...props
}: LoginInputProps) {
  return (
    <Input
      {...props}
      size={Sizes.LG}
      className={cn(LOGIN_CHROME, LOGIN_FOCUS, className)}
      inputClassName={cn(LOGIN_TEXT, inputClassName)}
    />
  );
}
